import "./ManageUser.css";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Session from "react-session-api";
import axios from "axios";
import React, { useState, useEffect } from 'react'
import "bootstrap/dist/css/bootstrap.min.css";
import "animate.css/animate.css";
import "font-awesome/css/font-awesome.css";
import { useNavigate } from "react-router-dom";


export default function Manageuser() {

    const apiurl = window.SERVICE_URL;
    //Implement Captcha

    const [userstype, setUserstype] = useState([]);
    const navigate = useNavigate();

    var token = "";
    var uid = "";
    var ID = 0;
    if (localStorage.getItem("loginsession") == null || localStorage.getItem("loginsession") == "") {
        navigate("/");
    }
    else {
        const result = JSON.parse(localStorage.getItem("loginsession"));
        token = result.AccessToken;
        uid = result.PartnerID;
        ID = result.UserID;
        console.log(result);
    }

    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false);
        /* setInput(() => "");*/
    }

    const handleShow = () => setShow(true);

    const [editUser, seteditUser] = useState(false);

    const editUserClose = () => { seteditUser(false); }
    //const editUserClose = () => seteditUser(false);
    const editUserShow = () => seteditUser(true);

    const [data, dataSet] = useState([]);
    useEffect(() => {
        getData();
    }, [dataSet]);

    const [DataById, DataByIdSet] = useState([]);
    useEffect(() => {
    }, [DataByIdSet]);

    async function getData() {
        await axios.get(apiurl + `api/GetAllSubAdmin?partnerId=` + uid,
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }).then(function (response) {
                dataSet(response.data);
            })
            .catch(error => {
                console.log(error.response)
            });
    }

    const [fileSelected, setFileSelected] = useState();
    const saveFileSelected = (e) => {
        setFileSelected(e.target.files[0]);
    };

    const SaveFileInfo = {
        FilePath: ""
    }

    const validationsform = (e) => {

        e.preventDefault();
        var fname = document.getElementById("FullName").value;
        var email = document.getElementById("EmailID");
        var mobile = document.getElementById("MobileNumber");
        var selectOption = document.getElementById("exampleSelect1");

        const showMsg = function (id, msg, color) {
            var element = document.getElementById(id);
            element.innerHTML = msg;
            element.style.color = color;
        }
        var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        var filtermobno = /^[0-9]{10,10}$/;

        if (fname == null || fname == "" || selectOption == "" || selectOption == null) {
            showMsg("FNameErr", "Full Name can't be blank", "red");
            showMsg("selectErr", "Pls Select the option ", "red");
            return false;
        }
        else {
            var FName = document.getElementById("FNameErr");
            FName.innerHTML = "";
        }

        if (!filtermobno.test(mobile.value)) {
            var mob = document.getElementById("mobileErr");
            mob.innerHTML = "Mobile number must be 10 digits..";
            mob.style.color = "red";
            return false;
        }
        else {
            var mob = document.getElementById("mobileErr");
            mob.innerHTML = "";
        }

        if (!filter.test(email.value)) {
            var emails = document.getElementById("emailErr");
            emails.innerHTML = "Please provide a valid email address.";
            emails.style.color = "red";
            return false;
        }
        else {
            var emails = document.getElementById("emailErr");
            emails.innerHTML = "";
        }
    }

    const importFile = async (e) => {

        validationsform(e);

        if (!fileSelected) {
            var pic = document.getElementById("fileErr");
            pic.innerHTML = "Please Select Profile Pic..";
            pic.style.color = "red";
            return false;

        }
        else {

            var pic = document.getElementById("fileErr");
            pic.innerHTML = "";
            const formData = new FormData();
            formData.append("file", fileSelected);
            await axios.post(`/api/FileUplaodOnServer`, formData,
                {
                    headers:
                    {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json"
                    },
                })

                .then(function (result) {
                    debugger;
                    if (result.data.filePath != "") {
                        SaveFileInfo.FilePath = result.data.fileName;
                        registerSubAdmin();
                    }
                })

                .catch(error => {
                    console.log(error.response)
                });
        }
    };

    const registerSubAdmin = async (e) => {
        // e.preventDefault();
        debugger;
        var fname = document.getElementById("FullName").value;
        var email = document.getElementById("EmailID").value;
        var mobile = document.getElementById("MobileNumber").value;
        var utyps = document.getElementById("exampleSelect1").value;
        var filepath = SaveFileInfo.FilePath;

        const subAdminForm = {
            FullName: fname,
            UserName: "",
            Password: "",
            EmailID: email,
            MobileNumber: mobile,
            Active: true,
            AddedOn: new Date(),
            AddedBy: ID,
            EditedOn: new Date(),
            EditedBy: 0,
            PartnerID: uid,
            UserType: utyps,
            ImagePath: SaveFileInfo.FilePath
        };
        //debugger;
        await axios
            .post(apiurl+`api/RegisterSubAdmin/`, subAdminForm,
                {
                    headers:
                    {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json"
                    },
                })

            .then(function (result) {
                alert(result.data.outMessage);
                setShow(false);
                handleClose();
                getData();
                //  setInput(() => "");
            })
            .catch(error => {
                console.log(error.response)
            });

    };

    useEffect(() => {

        const getusertype = async () => {
            const req = await fetch("/api/GetUserTypes", {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            const res = await req.json();
            console.log(res);
            setUserstype(await res);
        }
        getusertype();
    }, []);

    const [updatefileSelected, setupdateFileSelected] = useState();
    const UpdateFileSelected = (e) => {
        setupdateFileSelected(e.target.files[0]);
    };

    const UpdateFileInfo = {
        FilePath: ""
    }
    const UpdateimportFile = async (e) => {
        // debugger;
        const formData = new FormData();
        formData.append("file", updatefileSelected);

        await axios.post(apiurl + `api/FileUplaodOnServer`, formData,
            {
                headers:
                {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
            })

            .then(function (result) {

                if (result.data.filePath != "") {
                    UpdateFileInfo.FilePath = result.data.filePath;
                    UpdateSubAdmin();
                }
            })

            .catch(error => {
                console.log(error.response)
            });

    };

    async function RegisterGetSubAdminByID(id) {
        DataByIdSet([]);
        await axios.get(apiurl +`api/GetSubAdminByID?PartnerID=${uid}&SubAdminID=${id}`,
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                },
            }).then(function (response) {

                DataByIdSet(response.data);

            })
            .catch(error => {
                console.log(error.response)
            });
    }

    const UpdateSubAdmin = async (e) => {
        //  e.preventDefault();
        debugger;
        var id = document.getElementById("ID").value;
        var fullname = document.getElementById("FullName").value;
        var email = document.getElementById("EmailID").value;
        var mobileno = document.getElementById("MobileNumber").value;
        var usertyps = document.getElementById("exampleSelect1").value;
        var filepath = UpdateFileInfo.FilePath;
        const UpdateUsersData = {
            ID: id,
            FullName: fullname,
            UserName: "",
            Password: "",
            EmailID: email,
            MobileNumber: mobileno,
            Active: true,
            AddedOn: new Date(),
            AddedBy: ID,
            EditedOn: new Date(),
            EditedBy: 0,
            PartnerID: uid,
            UserType: usertyps,
            ImagePath: UpdateFileInfo.FilePath
        };

        await axios.post(apiurl + `api/RegisterSubAdmin`, UpdateUsersData,
            {
                headers:
                {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
            })
            .then(function (result) {

                alert(result.data.outMessage);
                seteditUser(false);
                getData();
            })
            .catch(error => {
                console.log(error.response)
            });
    };

    return (
        <>

            <div className="yoc-container  yoc-container--fluid  yoc-grid__item p-0 ">
                <div className="alert alert-light d-flex align-items-center mb-3 px-4 ">
                    <h5
                        className="yoc-subheader__title text-uppercase mb-0 pl-md-2"
                        style={{ fontSize: "14px;" }}
                    >
                        Setting
                    </h5>
                    <span className="seperator-danger ml-lg-3 ml-md-3 ml-sm-3 ml-2 mr-2 text-dark"></span>
                    <span className="text-danger font-weight-500 f13">
                        User Management
                    </span>
                </div>
                <div className="yoc-subheader__main bg-white px-3 mb-3 py-3">
                    <a
                        type="text"
                        href="#"
                        className="btn btn-pill btn-upper font-weight-normal ad-btn text-uppercase btn-orange waves-effect waves-light"
                    >
                        Manage User Type
                    </a>
                    <a
                        type="text"
                        href="#"
                        className="btn btn-pill btn-upper btn-bold text-uppercase waves-effect waves-light"
                    >
                        Manage User Rights
                    </a>
                </div>
            </div>

            <div className="yoc-portlet yoc-portlet--head--noborder yoc-portlet--height-fluid custom-side px-3 py-3 table-responsive">
                <div className="alert alert-light d-flex align-items-center mb-0 px-0 pt-0">
                    <h5 className="yoc-subheader__title text-uppercase mb-0 pl-md-2">
                        User Type lists
                    </h5>
                    <span className="seperator ml-lg-3 ml-md-3 ml-sm-3 ml-2"></span>

                    <a>
                        <span
                            className="badge badge-dark text-dark font-weight-500 f12 mr-2"
                            style={{ padding: "0.5em 0.75em" }}
                            onClick={handleShow}
                        >
                            <i className="fa fa-plus text-white"></i>
                        </span>
                    </a>
                    <span
                        className="badge badge-secondary text-dark font-weight-500 f12"
                        style={{ padding: "0.5em 0.75em" }}
                    >
                        ADD NEW USER TYPE
                    </span>
                    {/* <span className="badge badge-secondary text-dark font-weight-500 f12"
                >ADD NEW USER TYPE</span> */}
                </div>
                <table
                    className="table table-striped- table-bordered table-checkable"
                    id="yoc_table_1"
                >
                    <thead className="theadred">
                        <tr>
                            <th className="align-middle text-center">
                                <label className="yoc-checkbox yoc-checkbox--tick yoc-checkbox--success mb-3">
                                    <input type="checkbox" />
                                    <span></span>
                                </label>
                            </th>
                            <th>User</th>
                            <th style={{ width: "30%" }}>
                                <span className="invisible">QuesQuestionsQuestisQue</span> Usage
                                History{" "}
                            </th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((user, key) => (
                            <tr key={key}>
                                <td className="text-center">
                                    <label className="yoc-checkbox yoc-checkbox--tick yoc-checkbox--success">
                                        <input type="checkbox" />
                                        <span></span>
                                    </label>
                                </td>
                                <td>
                                    <div className="yoc-user-card-v2">
                                        <div className="">
                                            <img
                                                src={"http://192.168.1.120:8087/ProfileImage/" + user.partnerID + "/" + user.imagePath}
                                                alt="user"
                                                className="img-table-users"
                                            />
                                        </div>
                                        <div className="yoc-user-card-v2__details">
                                            <span className="yoc-user-card-v2__name font-weight-500 f14 text-dark">
                                                {user.fullName}
                                            </span>
                                            <span className="yoc-user-card-v2__email">
                                                {user.mobileNumber}
                                            </span>
                                            <br />
                                            <span className="yoc-widget4__sub text-info ln-20">
                                                {user.emailID}
                                            </span>
                                            <br />
                                            <span className="yoc-widget4__sub text-danger ln-20">
                                                {user.fullName}
                                            </span>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="yoc-user-card-v2">
                                        <div className="yoc-user-card-v2__details">
                                            <span className="yoc-user-card-v2__email ln-14">
                                                Questions Added / Corrected{" "}
                                                <strong>
                                                    <span className="text-dark">: 3009 / 500</span>
                                                </strong>{" "}
                                                (This Month)
                                            </span>
                                        </div>
                                    </div>
                                    <div className="yoc-user-card-v2">
                                        <div className="yoc-user-card-v2__details">
                                            <span className="yoc-user-card-v2__email ln-14">
                                                Questions Created{" "}
                                                <strong>
                                                    <span className="text-dark">: 3009</span>
                                                </strong>{" "}
                                                (Till Date)
                                            </span>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="yoc-portlet__head-toolbar">
                                        <div className="dropdown dropdown-inline">
                                            <button
                                                type="button"
                                                className="btn btn-clean btn-sm btn-icon btn-icon-lg"
                                                data-toggle="dropdown"
                                                aria-haspopup="true"
                                                aria-expanded="false"
                                            >
                                                <i className="yoc-menu__link-icon flaticon2-browser-2"></i>
                                            </button>

                                            {/* <i className="yoc-menu__link-icon flaticon2-pen"></i> */}

                                            <button
                                                className="btn btn-primary"
                                                onClick={() => {
                                                    RegisterGetSubAdminByID(user.id);
                                                    /*    setInput(() => "");*/
                                                    editUserShow();

                                                }}
                                            >
                                                {/*  {" "}*/}
                                                <i className="yoc-menu__link-icon flaticon2-pen"></i>
                                            </button>

                                            <div
                                                className="dropdown-menu dropdown-menu-right"
                                                x-placement="bottom-end"
                                                style={{
                                                    position: "absolute",
                                                    willChange: "transform",
                                                    top: "0px",
                                                    left: "0px",
                                                    transform: "translate3d(32px, 32px, 0px)",
                                                }}
                                            >
                                                <ul className="yoc-nav custom-action-list">
                                                    <li className="yoc-nav__item">
                                                        <a href="#" className="yoc-nav__link">
                                                            <i className="yoc-nav__link-icon flaticon2-line-chart"></i>
                                                            <span className="yoc-nav__link-text">
                                                                Manage Rights
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li className="yoc-nav__item">
                                                        <a href="#" className="yoc-nav__link">
                                                            <i className="yoc-nav__link-icon flaticon2-bell-alarm-symbol"></i>
                                                            <span className="yoc-nav__link-text">
                                                                Send Notifications
                                                            </span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        )).reverse()}
                    </tbody>
                </table>
            </div>

            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <form className="yoc-form yoc-form--fit yoc-form--label-right">
                    <Modal.Header>
                        <Modal.Title>Add New User</Modal.Title>
                        <Button onClick={handleClose}>X</Button>
                    </Modal.Header>

                    <Modal.Body>
                        <div className="form-group row yoc-margin-t-10">
                            <div className="col-md-12">
                                <input
                                    type="text"
                                    id="FullName"
                                    className="form-control"
                                    placeholder="FullName"
                                    name="FullName"
                                />
                                <p id="FNameErr"></p>
                            </div>
                        </div>


                        <div className="form-group row">
                            <div className="col-md-12">
                                <input
                                    type="text"
                                    id="MobileNumber"
                                    className="form-control"
                                    placeholder="MobileNumber"
                                    name="MobileNumber"
                                    maxLength="10"
                                />
                                <p id="mobileErr"></p>
                            </div>
                        </div>

                        <div className="form-group row">
                            <div className="col-md-12">
                                <input
                                    type="email"
                                    id="EmailID"
                                    className="form-control"
                                    placeholder="EmailId"
                                    name="EmailID"
                                />
                                <p id="emailErr"></p>
                            </div>
                        </div>

                        <div className="form-group row">
                            <div className="col-md-12">
                                <input
                                    type="file"
                                    id="File"
                                    className="form-control"
                                    name="File"
                                    accept="image/*"
                                    onChange={saveFileSelected}
                                />
                                <p id="fileErr"></p>
                            </div>
                        </div>

                        <div className="form-group row">
                            <div className="col-md-12">
                                <select
                                    className="form-control  form-control-sm"
                                    id="exampleSelect1"
                                    style={{ height: "calc(1.8em + 1.3rem + 2px)" }}
                                    name="UserType"

                                >
                                    <option value="">--select user type--</option>
                                    {userstype.map((resuser) => (
                                        <option key={resuser.userTypeID} value={resuser.userTypeID}>
                                            {resuser.name}
                                        </option>
                                    ))}
                                </select>
                                <p id="selectErr"></p>
                            </div>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="primary" onClick={importFile}>
                            Add User
                        </Button>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>

            <Modal
                show={editUser}
                onHide={editUserClose}
                backdrop="static"
                keyboard={false}
            >
                <form className="yoc-form yoc-form--fit yoc-form--label-right">
                    <Modal.Header>
                        <Modal.Title>Edit New User</Modal.Title>
                        <Button onClick={editUserClose}>X</Button>
                    </Modal.Header>

                    <Modal.Body>

                        <div className="form-group row yoc-margin-t-10">
                            <div className="col-md-12">
                                <input
                                    type="text"
                                    id="ID"
                                    className="form-control d-none"
                                    placeholder="id"
                                    defaultValue={DataById.id}
                                    name="ID"
                                />

                                <input
                                    type="text"
                                    id="FullName"
                                    className="form-control"
                                    placeholder="FullName"
                                    defaultValue={DataById.fullName}
                                    name="FullName"
                                />
                            </div>
                        </div>

                        <div className="form-group row">
                            <div className="col-md-12">
                                <input
                                    type="text"
                                    id="EmailID"
                                    className="form-control"
                                    placeholder="Emailid"
                                    defaultValue={DataById.emailID}
                                    name="EmailID"
                                />
                            </div>
                        </div>

                        <div className="form-group row">
                            <div className="col-md-12">
                                <input
                                    type="text"
                                    id="MobileNumber"
                                    className="form-control"
                                    placeholder="MobileNumber"
                                    defaultValue={DataById.mobileNumber}
                                    name="MobileNumber"
                                    required
                                />
                            </div>
                        </div>

                        <div className="form-group row">
                            <div className="col-md-12">
                                <input
                                    type="file"
                                    id="File"
                                    className="form-control"
                                    name="File"
                                    accept="image/*"
                                    defaultValue={DataById.ImagePath}
                                    onChange={UpdateFileSelected}
                                />
                            </div>
                        </div>

                        <div className="form-group row">
                            <div className="col-md-12">
                                <select
                                    value={DataById.userType}
                                    className="form-control  form-control-sm"
                                    id="exampleSelect1"
                                    style={{ height: "calc(1.8em + 1.3rem + 2px)" }}
                                    name="UserType"
                                >
                                    <option>--select user type--</option>
                                    {userstype.map((resuser) => (
                                        <option key={resuser.userTypeID} value={resuser.userTypeID}>
                                            {resuser.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button type="button" variant="primary" onClick={UpdateimportFile}>
                            update User
                        </Button>

                        <Button variant="primary" onClick={editUserClose}>
                            Cancel
                        </Button>

                    </Modal.Footer>
                </form>
            </Modal>

        </>
    );
}